import { ContactDealerPhoneDetailsProps } from '../../../types';
import styles from '../../../Product.module.scss';
import cx from 'classnames';

export const ContactDealerPhoneDetails = ({
  label,
  textClassName,
  phone
}: ContactDealerPhoneDetailsProps) => {
  return (
    <p className={cx(textClassName, styles['product-text'])}>
      <span className={cx('fw-bold', textClassName, styles['product-text'])}>
        {label}
      </span>
      <br />
      <a href={`tel:${phone}`}>{phone}</a>
    </p>
  );
};
